import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.componente
    ? _c(
        VCol,
        { attrs: { cols: _vm.value.colunas } },
        [
          _c(_vm.componente, {
            tag: "component",
            attrs: { value: _vm.value },
            scopedSlots: _vm._u(
              [
                {
                  key: "children",
                  fn: function () {
                    return _vm._l(_vm.value.filhos, function (filho, i) {
                      return _c(_vm.getComponente(filho.tipo), {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !_vm.value.filhosDependentes ||
                              (_vm.value.filhosDependentes && _vm.value.opcao),
                            expression:
                              "\n          !value.filhosDependentes || (value.filhosDependentes && value.opcao)\n        ",
                          },
                        ],
                        key: i,
                        tag: "component",
                        attrs: {
                          value: filho,
                          disable:
                            !_vm.value.habilitado ||
                            (_vm.value.filhosDependentes &&
                              _vm.value.opcao === false),
                        },
                      })
                    })
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3001134740
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }